export default __webpack_public_path__ + "static/media/layout_1.0352764d.png";